import {
  Heading,
  Tabs,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useProviderTasks } from '../../api/providerHome/useProviderTasks';
import { TaskCard } from './TaskCard';
import { TasksColumnSkeleton } from './TasksColumnSkeleton';
import { TasksEmptyState } from './TasksEmptyState';

export const TasksColumn = ({ memberId }: { memberId?: number }) => {
  const { tasks, isLoading, isError } = useProviderTasks({
    healthieId: memberId,
  });
  const [activeIndex, setActiveIndex] = useState(0);

  const tabs = [
    {
      label: 'All',
      count: tasks.length,
      content: !memberId ? (
        <VStack
          flex={1}
          h={'100%'}
          alignItems={'center'}
          justifyItems={'center'}
        >
          <Text>Select a member to view tasks</Text>
        </VStack>
      ) : isLoading ? (
        <TasksColumnSkeleton />
      ) : isError ? (
        <Text color="red.500">
          There was an error while loading the tasks, please try again later.
        </Text>
      ) : tasks.length ? (
        <VStack gap={2} px={8} pb={4} overflowY={'scroll'} h="100%">
          {tasks.map((task) => (
            <TaskCard key={task.id} task={task} />
          ))}
        </VStack>
      ) : (
        <TasksEmptyState />
      ),
    },
  ];

  return (
    <Box
      flex={1}
      minW={0}
      minH={0}
      h="100%"
      overflow="hidden"
      pt={6}
      display="flex"
      flexDirection="column"
    >
      <Heading size="sm" px={8} mb={3} flexShrink={0}>
        Tasks
      </Heading>

      <Tabs
        tabs={tabs}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        fitContent
        flex={1}
        minH={0}
      />
    </Box>
  );
};
